export default __webpack_public_path__ + "static/media/system_04_02.82b440f3.jpg";